import styled from 'styled-components'
import {darken, setLightness} from 'polished'

import {colorWine, colorWhite} from '../../cssConstants/colors'
import {weightBold} from '../../cssConstants/typography'
import {buttonMixin} from '../../cssMixins/buttons'

export const Button = styled.button`
  ${buttonMixin};
  flex-direction: column; /* iOS9 legacy support */
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);

  background-color: ${colorWhite};
  color: ${colorWine};
  border-color: ${colorWine};
  font-weight: ${weightBold};

  &:hover {
    &,
    * {
      color: ${colorWhite};
    }
    background-color: ${darken(0.05, colorWine)};
    border-color: ${setLightness(0.4, colorWine)};
  }
`
